import { getAuth } from "firebase/auth";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// fetchMealPlan.js
export const fetchMealPlan = async () => {
  const auth = getAuth();
  const token = await auth.currentUser.getIdToken();

  const res = await fetch(`${API_BASE_URL}/api/user/meal-plan`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) throw new Error("Failed to fetch meal plan");

  const data = await res.json();
console.log("🐛 Raw mealPlan data from API:", JSON.stringify(data, null, 2));
return data.mealPlan;
};

